import { css } from 'lit';
export default css `
  :host {
    box-sizing: border-box;
    display: block;
    position: relative;

    --private-large-padding: 6px 12px;
    --private-large-label-padding: 4px 0;
    --private-large-button-size: 28px;
    --private-large-button-margin: 0 -8px 0 2px;
    --private-large-button-icon-size: 10px;

    --private-medium-padding: 2px 8px;
    --private-medium-label-padding: 2px 0;
    --private-medium-button-size: 20px;
    --private-medium-button-margin: 0 -4px 0 2px;
    --private-medium-button-icon-size: 8px;
  }

  .chip {
    display: inline-flex;
    align-items: center;
    padding: 6px 12px;
    background-color: var(--amityeko-color-gray-9);
    border-radius: var(--amityeko-radius-large);
    transition: 50ms background-color, 50ms color;
  }

  .chip--selected {
    background-color: var(--private-selected-bg-color, var(--amityeko-color-gray-9));
  }

  .chip--clickable {
    user-select: none;
  }

  .chip--clickable:not([disabled]) {
    cursor: pointer;
  }

  .chip--clickable[disabled] {
    cursor: not-allowed;
  }

  .chip--clickable-ui:not([disabled]):hover {
    background-color: var(--amityeko-color-gray-8);
  }

  .chip--clickable-ui.chip--selected:not([disabled]):hover {
    background-color: var(--private-selected-hover-color, var(--amityeko-color-gray-8));
  }

  .chip--clickable-ui:not([disabled]):active {
    background-color: var(--amityeko-color-gray-7);
  }

  .chip--clickable-ui.chip--selected:not([disabled]):active {
    background-color: var(--private-selected-active-color, var(--amityeko-color-gray-7));
  }

  .chip__label::part(base) {
    color: var(--amityeko-color-gray-1);
  }

  .chip--selected .chip__label::part(base) {
    color: var(--private-selected-color, var(--amityeko-color-gray-1));
  }

  .chip[disabled] .chip__label::part(base) {
    color: var(--amityeko-color-gray-6);
  }

  .chip__button {
    display: flex;
    justify-content: center;
  }

  .chip__label::part(base) {
    padding: var(--private-large-label-padding);
  }

  .chip__button {
    --private-circle-button-size: var(--private-large-button-size);
    margin: var(--private-large-button-margin);
  }

  .chip__button ::slotted(amityeko-icon) {
    --amityeko-icon-size: var(--private-large-button-icon-size);
  }

  ::slotted([slot='prefix']) {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  ::slotted([slot='suffix']) {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }
`;
//# sourceMappingURL=styles.js.map